import { Pipe, PipeTransform } from '@angular/core';
import { LogbookRecordViolation, LogbookRecordWarning } from '@fleet-beat/api';
import {
  SelectOption,
  ViolationTypeEnum,
  ViolationTypeOptions,
  WarningType,
  WarningTypeOptions,
} from '@fleet-beat/core';

interface ViolationsAndWarningsDisplay {
  label: string;
  amount: number;
}

@Pipe({
  name: 'violationWarningTooltipPipe',
})
export class ViolationWarningTooltipPipe implements PipeTransform {
  transform(value: null, violations: LogbookRecordViolation[], warnings: LogbookRecordWarning[]): string {
    let warningsToDisplay: ViolationsAndWarningsDisplay[] = [];
    let violationsToDisplay: ViolationsAndWarningsDisplay[] = [];

    if (warnings.length) {
      const countWarningsOccurrences = warnings.reduce((acc: Record<string, number>, element: LogbookRecordWarning) => {
        acc[element.type] = (acc[element.type] || 0) + 1;
        return acc;
      }, {} as Record<string, number>);

      const uniqueWarningsList: `${WarningType}`[] = [
        ...new Set(warnings.map((item: LogbookRecordWarning) => item.type)),
      ];

      const formattedWarnings: ViolationsAndWarningsDisplay[] = uniqueWarningsList.map((warning: `${WarningType}`) => {
        return {
          label: WarningTypeOptions.find((status: SelectOption) => status.value === warning)?.label,
          amount: countWarningsOccurrences[warning],
        };
      });

      warningsToDisplay = [...formattedWarnings];
    }
    if (violations.length) {
      const countViolationsOccurrences = violations.reduce(
        (acc: Record<string, number>, element: LogbookRecordViolation) => {
          acc[element.type] = (acc[element.type] || 0) + 1;
          return acc;
        },
        {} as Record<string, number>,
      );

      const uniqueViolationsList: `${ViolationTypeEnum}`[] = [
        ...new Set(violations.map((item: LogbookRecordViolation) => item.type)),
      ];

      const formattedViolations: ViolationsAndWarningsDisplay[] = uniqueViolationsList.map(
        (violation: `${ViolationTypeEnum}`) => {
          return {
            label: ViolationTypeOptions.find((status: SelectOption) => status.value === violation)?.label,
            amount: countViolationsOccurrences[violation],
          };
        },
      );

      violationsToDisplay = [...formattedViolations];
    }

    const itemsToConcat: ViolationsAndWarningsDisplay[] = [...violationsToDisplay, ...warningsToDisplay];
    let valueToDisplay: string = '';
    itemsToConcat.forEach((item: ViolationsAndWarningsDisplay, i: number) => {
      valueToDisplay += `${item.label + (item.amount > 1 ? ' (' + item.amount + ')' : '')}${
        itemsToConcat.length - 1 != i ? ',' : ''
      } `;
    });

    return valueToDisplay;
  }
}
